import React, { useEffect, useState, useCallback } from "react";
import { Modal, Table } from "react-bootstrap";
import { instance } from "../../utils/utils";
import './styles.css'
import InlineModal from "../info-modal/infoModal";

const PreRegisteredUsersListModal = ({ show, onHide }) => {
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [deleting, setDeleting] = useState(null);
    const [confirmDeleteUserEmail, setConfirmDeleteUserEmail] = useState(null);

    const fetchUsers = useCallback(async () => {
        setLoading(true);
        try {
            const res = await instance.get(
                "memberships/corp/company/members/preregisters"
            );
            setUsers(res.data || []);
        } catch (error) {
            console.error("Error cargando usuarios pre-registrados", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (show) {
            void fetchUsers();
        }
    }, [show, fetchUsers]);

    const handleDelete = async (email) => {
        if (!email) return;
        setDeleting(email);

        try {
            const formData = new FormData();
            formData.append("email", email);

            await instance.delete(
                "memberships/corp/company/members/preregisters/delete",
                { data: formData }
            );

            await fetchUsers();
        } catch (error) {
            console.error("Error eliminando usuario", error);
        } finally {
            setDeleting(null);
            setConfirmDeleteUserEmail(null);
        }
    };

    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                centered
                className="pre-registered-users-list-modal"
            >
                <Modal.Header className="pre-registered-users-list-header position-relative text-center justify-content-center p-4">
                    <span className="pre-registered-users-list-title text-center w-100">
                        Usuarios pendientes por crear
                    </span>
                    <div className="position-absolute end-0 top-50 translate-middle-y me-3">
                        <svg
                            type="button"
                            className="btn-close pre-registered-users-list-close"
                            aria-label="Close"
                            onClick={onHide}
                            xmlns="http://www.w3.org/2000/svg"
                            width="26"
                            height="27"
                            viewBox="0 0 26 27"
                            fill="none"
                        >
                            <path
                                d="M13 1.5C19.2984 1.5 24.5 6.81872 24.5 13.5C24.5 20.1813 19.2984 25.5 13 25.5C6.70158 25.5 1.5 20.1813 1.5 13.5C1.5 6.81872 6.70158 1.5 13 1.5Z"
                                stroke="#9DACBD"
                                strokeWidth="3"
                            />
                            <path d="M8 8.5L17.5 18" stroke="#9DACBD" strokeWidth="2" strokeLinecap="round" />
                            <path d="M17.5 8.5L8 18" stroke="#9DACBD" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </div>
                </Modal.Header>

                <Modal.Body className="pre-registered-users-list-body px-5">
                    {loading ? (
                        <div className="pre-registered-users-list-loading text-center py-4">
                            Cargando...
                        </div>
                    ) : (
                        <div className="pre-registered-users-list-table table-responsive px-3">
                            <Table className="align-middle mb-0">
                                <thead>
                                <tr>
                                    <th className="text-start" style={{ width: "40%" }}>Correo Electrónico</th>
                                    <th className="text-start" style={{ width: "40%" }}>Membresía</th>
                                    <th className="text-center" style={{ width: "20%" }}></th>
                                </tr>
                                </thead>
                                <tbody>
                                {users.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan="3"
                                            className="pre-registered-users-list-empty text-center py-3"
                                        >
                                            No hay usuarios pendientes.
                                        </td>
                                    </tr>
                                ) : (
                                    users.map((u) => (
                                        <tr key={u.id}>
                                            <td className="text-start">{u.email}</td>
                                            <td className="text-start">{u.membership}</td>
                                            <td className="text-center">
                                                <button
                                                    className="pre-registered-users-list-delete btn btn-link text-danger p-0"
                                                    onClick={() => setConfirmDeleteUserEmail(u.email)}
                                                    disabled={deleting === u.email}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none">
                                                        <path d="M11.9381 18.5439H4.26074C4.20935 18.5315 4.15857 18.5151 4.10632 18.5073C3.30212 18.389 2.66846 18.0125 2.32239 17.2578C2.18079 16.9496 2.07019 16.6119 2.02625 16.277C1.83716 14.8427 1.67773 13.4045 1.5083 11.9676C1.36829 10.7761 1.22913 9.58447 1.09033 8.39288C1.01697 7.76489 0.944702 7.13678 0.871094 6.5H15.4736C15.3267 7.72919 15.1812 8.94397 15.0354 10.1587C14.8845 11.4156 14.7362 12.6729 14.5809 13.9293C14.4775 14.7667 14.3986 15.6091 14.2461 16.4377C14.0651 17.4205 13.525 18.137 12.5182 18.4205C12.3284 18.474 12.1317 18.5035 11.9381 18.5439ZM7.6272 12.3905C7.6272 12.5472 7.6272 12.7039 7.6272 12.8607C7.6272 13.8011 7.62512 14.7414 7.62891 15.6818C7.63 15.9781 7.84619 16.2055 8.12793 16.2265C8.40271 16.2469 8.64978 16.0596 8.70398 15.7833C8.71777 15.7133 8.71436 15.6395 8.71436 15.5673C8.71497 13.4454 8.71497 11.3233 8.71472 9.20154C8.71472 9.14722 8.71729 9.09265 8.71216 9.03876C8.68396 8.73553 8.4342 8.52319 8.1311 8.54211C7.83557 8.56061 7.6283 8.79321 7.62793 9.11713C7.62634 10.2083 7.6272 11.2994 7.6272 12.3905ZM5.72766 12.3702C5.72766 11.3265 5.72791 10.2827 5.72717 9.23883C5.72717 9.16064 5.72754 9.08142 5.7168 9.00427C5.67737 8.72296 5.44482 8.53101 5.16138 8.54102C4.85706 8.55176 4.63965 8.78204 4.63916 9.11963C4.63635 11.2977 4.63757 13.4758 4.63867 15.6539C4.63892 15.7137 4.64734 15.7749 4.6626 15.8326C4.72656 16.0712 4.95654 16.2365 5.20483 16.227C5.45422 16.2173 5.6687 16.036 5.71179 15.7902C5.72644 15.7077 5.72693 15.622 5.72693 15.5378C5.72791 14.482 5.72766 13.4261 5.72766 12.3702ZM10.6165 12.3774C10.6165 13.4332 10.6161 14.4892 10.6169 15.545C10.6169 15.6231 10.6173 15.7026 10.6299 15.7793C10.6715 16.0341 10.8896 16.2206 11.146 16.2271C11.4031 16.2336 11.6324 16.0594 11.6852 15.8077C11.7034 15.7202 11.7056 15.6281 11.7056 15.5381C11.7068 13.4324 11.7065 11.3268 11.7058 9.22113C11.7058 9.14294 11.7046 9.06354 11.6914 8.987C11.6439 8.71295 11.4164 8.53149 11.1394 8.54095C10.8228 8.55176 10.6179 8.78845 10.6172 9.15558C10.6151 10.2295 10.6165 11.3034 10.6165 12.3774Z" fill="#B5C1CD"/>
                                                        <path d="M3.71427 2.32088C3.85868 1.86147 3.95243 1.42751 4.12943 1.03109C4.4379 0.340721 4.98661 -0.00467722 5.76432 0.00209768C7.29667 0.0153423 8.82987 0.0224224 10.3621 0.000266625C11.3671 -0.0143818 11.8781 0.576805 12.1109 1.21963C12.2166 1.51174 12.2644 1.82497 12.3373 2.12881C12.3511 2.18648 12.3597 2.24563 12.3737 2.32015C12.9247 2.32015 13.4676 2.30416 14.0091 2.32412C14.7178 2.35024 15.3147 2.63802 15.785 3.17306C16.2195 3.66811 16.376 4.25436 16.3266 4.90139C16.3056 5.17721 16.0953 5.37606 15.8163 5.39761C15.7561 5.40231 15.6956 5.39956 15.6352 5.39956C10.657 5.39968 5.67912 5.39968 0.701088 5.39962C0.190712 5.39962 0.0080947 5.2087 0.0002822 4.70199C-0.0207139 3.30575 1.13334 2.37069 2.3101 2.324C2.7913 2.30495 3.27372 2.32088 3.71427 2.32088ZM11.2591 2.30856C11.2216 1.95943 11.1548 1.64443 10.9709 1.3652C10.8532 1.18636 10.6883 1.09304 10.47 1.09316C8.87064 1.09408 7.2714 1.0942 5.67216 1.09292C5.48295 1.0928 5.33024 1.16427 5.21708 1.31203C4.99406 1.60397 4.93095 1.94863 4.88065 2.30856H11.2591Z" fill="#B5C1CD"/>
                                                    </svg>
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            {confirmDeleteUserEmail && (
                <InlineModal
                    show
                    title="¿Deseas eliminar este usuario?"
                    primaryAction={{
                        label: "Confirmar",
                        onClick: () => handleDelete(confirmDeleteUserEmail),
                        loading: deleting === confirmDeleteUserEmail
                    }}
                    secondaryAction={{
                        label: "Cancelar",
                        onClick: () => setConfirmDeleteUserEmail(null),
                    }}
                />
            )}
        </>
    );
};

export default PreRegisteredUsersListModal;
